export const userClickEditFreshRecipe = () => ({
  type: 'Clicks edit fresh recipes',
});

export const userClickEditBakedRecipe = () => ({
  type: 'Clicks edit baked recipes',
});
